import Drawer from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import React from 'react';
import Box from '@mui/material/Box';
import { IconButton } from '@/components/icon-button';
import { iconNames } from '@/components/icons';
import { SPACE } from '@/constants';
import styled from '@emotion/styled';

type CloseButtonBoxProps = {
  anchor?: 'left' | 'right';
};

const CloseButtonBox = styled(Box)<CloseButtonBoxProps>`
  background: transparent;
  display: block;
  position: absolute;

  left: ${(props) => (props.anchor === 'left' ? SPACE.X1 : 'auto')};

  right: ${(props) => (props.anchor === 'right' ? SPACE.X1 : 'auto')};
  top: ${SPACE.X1};
  z-index: 1;
`;

const StyledPaper = styled(Paper)`
  width: 584px;
  max-width: 90%;
  min-height: 100%;
`;

const StyledIconButton = styled(IconButton)`
  padding: 12px;
`;

type PanelProps = {
  anchor: 'left' | 'right';
  ariaLabel?: string;
  ariaLabelledBy?: string;
  children?: React.ReactNode | React.JSX.Element;
  isOpen?: boolean;
  onClose?: () => void;
};

const Panel = ({
  anchor = 'left',
  ariaLabel,
  ariaLabelledBy,
  children,
  isOpen = false,
  onClose = () => {},
}: PanelProps) => {
  return (
    <Drawer
      anchor={anchor}
      open={isOpen}
      onClose={onClose}
      role="dialog"
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      variant="temporary"
      PaperProps={{
        component: StyledPaper,
      }}
    >
      <CloseButtonBox anchor={anchor}>
        <StyledIconButton
          ariaLabel="Close navigation"
          iconName={iconNames.close}
          name="Close navigation"
          onClick={onClose}
        />
      </CloseButtonBox>
      {children}
    </Drawer>
  );
};

export { Panel };
